import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
// import authGuard
import { authGuard } from "../auth/authGuard";
import { authGuardAdmin } from "../auth/authGuardAdmin";
import moment from 'moment'

Vue.use(VueRouter)


Vue.filter('toCurrency', function (value) {
  var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
  });
  if (value) {
    return formatter.format(value);
  } else {
    return formatter.format(0);
  }
});

Vue.filter('toUSPhoneNumber', function (value) {
  value = value.replace(/[+-]/g, '');
  if (value.substring(0,1) == '1') {
    value = value.slice(1);
  }
  const a = value.slice(0,3);
  const b = value.slice(3,6);
  const c = value.slice(6);
  return '('+a+')'+b+'-'+c;
});

Vue.filter('toTwelveHours', function (timestr) {
  return moment('2000-01-01T'+timestr).format('h:mma');
});

Vue.filter('toTextDate', function (date) {
  return moment(date).format('ddd Do MMM');
});

Vue.filter('dateFormat', function (value, fromutc=false) {
  if (fromutc==true) {
    return moment(value).format('ddd, MMM Do ') + ' at ' +moment(value).format(' h:mma');
  } else {
    return moment(value).utc().format('ddd, MMM Do ') + ' at ' +moment(value).utc().format(' h:mma');
  }
});

Vue.filter('dateFormatShort', function (value) {
  return moment(value).utc().format('MM/DD, h:mma');
});

Vue.filter('toUSDateFormat', function (value, fromutc=false) {
  if (fromutc==true) {
    return moment(value).format('MM/DD/YYYY ');
  } else {
    return moment(value).utc().format('MM/DD/YYYY ');
  }
});

Vue.filter('toWeekNumber', function(value) {
  return moment(value).isoWeek();
});

Vue.filter('toMonthNumber', function(value) {
  return moment(value).month() + 1;
});

Vue.filter('placeOrderDate', function(value) {
  if (value == moment().format('YYYY-MM-DD')) {
    return 'Today';
  } else {
    return moment(value).format('ddd Do MMM');
  }
});

// Components
import Dashboard from "../views/Dashboard.vue";
import Orders from "../views/Orders.vue";
import PlaceOrder from "../views/PlaceOrder.vue";
import Locations from "../views/Locations.vue";
import MenuProductLists from "../views/MenuProductLists.vue";
import MenuCategories from "../views/MenuCategories.vue";
import MenuItems from "../views/MenuItems.vue";
import MenuOptions from "../views/MenuOptions.vue";
import MenuChoices from "../views/MenuChoices.vue";
import Reports from "../views/Reports.vue";
import Transactions from "../views/Transactions.vue";
import Settings from "../views/Settings.vue";
import GiftCards from "../views/GiftCards.vue";
import Onboard from "../views/Onboard.vue";
import Printers from "../views/Printers.vue";
import OrderOverview from "../reports/OrderOverview.vue";
import OrderDetails from "../reports/OrderDetails.vue";
import ZReport from "../reports/ZReport.vue";
import Performance from "../reports/Performance.vue";


  const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    beforeEnter: authGuard
  },
  {
    path: '/Orders',
    name: 'Orders',
    component: Orders,
    beforeEnter: authGuard
  },
  {
    path: '/PlaceOrder/:vendorId',
    name: 'PlaceOrder',
    component: PlaceOrder,
    props: true,
    beforeEnter: authGuard
  },
  {
    path: '/Locations',
    name: 'Locations',
    component: Locations,
    beforeEnter: authGuard
  },
  {
    path: '/MenuCategories',
    name: 'MenuCategories',
    component: MenuCategories,
    beforeEnter: authGuard
  },
  {
    path: '/MenuProductLists',
    name: 'MenuProductLists',
    component: MenuProductLists,
    beforeEnter: authGuard
  },
  {
    path: '/MenuItems',
    name: 'MenuItems',
    component: MenuItems,
    beforeEnter: authGuard
  },
  {
    path: '/MenuOptions',
    name: 'MenuOptions',
    component: MenuOptions,
    beforeEnter: authGuard
  },
  {
    path: '/MenuChoices',
    name: 'MenuChoices',
    component: MenuChoices,
    beforeEnter: authGuard
  },
  {
    path: '/Reports',
    name: 'Reports',
    component: Reports,
    beforeEnter: authGuard
  },
  {
    path: '/Transactions',
    name: 'Transactions',
    component: Transactions,
    beforeEnter: authGuard
  },
  {
    path: '/GiftCards',
    name: 'GiftCards',
    component: GiftCards,
    beforeEnter: authGuard
  },
  {
    path: '/Printers',
    name: 'Printers',
    component: Printers,
    beforeEnter: authGuard
  },
  {
    path: '/Settings',
    name: 'Settings',
    component: Settings,
    beforeEnter: authGuard
  },
  { path: 'http://localhost:3000/Settings', redirect: {name: 'Settings'}},
  {
    path: '/Onboard',
    name: 'Onboard',
    component: Onboard,
    beforeEnter: authGuardAdmin
  },
  {
    path: '/OrderOverview',
    name: 'OrderOverview',
    component: OrderOverview,
    beforeEnter: authGuard
  },
  {
    path: '/OrderDetails',
    name: 'OrderDetails',
    component: OrderDetails,
    beforeEnter: authGuard
  },
  {
    path: '/ZReport',
    name: 'ZReport',
    component: ZReport,
    beforeEnter: authGuard
  },
  {
    path: '/Performance',
    name: 'Performance',
    component: Performance,
    beforeEnter: authGuardAdmin
  },

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
